import { Fragment } from "react/jsx-runtime";
import HeroSection from "../components/common/HeroSection";
import data from "../femcare-content.json";
import SymptomChecker from "../components/Home/SymptomTracker";
import CheckSymptoms from "../components/Home/WhatStages";
import MeetDoctors from "../components/Home/MeetDoctors";
import KeyServices from "../components/Home/KeyServices";
import HealthPrograms from "../components/Home/HealthPrograms";
import WhyTrustUs from "../components/Home/WhyTrustUs";
import Testimonials from "../components/Home/Testimonals";
import CallToAction from "../components/common/CTASection";
import PatientJourney from "../components/Home/PatientsJourney";
import useCurrentLocation from '../hooks/useCurrentLocation';
import DigitalHealthFAB from "../components/Digitalhealth";
import { useEffect, useState } from "react";
import TrustBadges from "../components/Home/TrustBadgeHome";
import { BASE_URL } from "../api/apiClient";
import TalkToCareGuideButton from "../components/whatsapp/whatsappIntegration";
import PopularConversations from "../components/Home/PopularConversations";
// import PopularConversations from "../components/Home/PopularConversations";
import content from '../components/Home/PopularconversationsContent.json'
import { TOPIC_GLYPHS } from "../components/Home/TopicPillGlyphs";
import TopicPillsCard from "../components/Home/Topicpillscard";
import pillsData from '../components/Home/Topicpillsdata.json'

import quickActionsData from '../components/Home/Quickactionsdata.json';
import QuickActionsPanel from "../components/Home/Quickactionspanel";

const { slides } = data.sections.hero;

const FEMCARE_API_URL = `${BASE_URL}/api/femcare/`;
console.log(BASE_URL,"this is the baseurl");
const Home = () => {
  const location = useCurrentLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  console.log({ PopularConversations, content },"vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv");
  const[heroData,setHeroData]=useState({});
  useEffect(() => {
    let cancelled = false;

    fetch(FEMCARE_API_URL)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to fetch navbar: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        // setNavbar(data.navbar);
        setHeroData(data?.sections?.hero?.slides?.slice(0,1))
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  console.log(location);

  return (
    <Fragment>
        <DigitalHealthFAB/>
        <HeroSection slides={heroData} autoPlayInterval={13000} loading={loading} />
        {/* <PopularConversations/> */}
{/* <PopularConversations content={content}/> */}
{/* <TOPIC_GLYPHS/> */}
{/* <TopicPillsCard data={pillsData}/> */}
{/* <QuickActionsPanel data={quickActionsData}  /> */}
        <CheckSymptoms />
        <KeyServices />
        <SymptomChecker />
        <MeetDoctors />
        <HealthPrograms />
        {/* <WhyTrustUs /> */}
        <div className="bg-white">
        <TrustBadges/>
        </div>
        <PatientJourney />
        <Testimonials />
        <CallToAction data={data?.callToAction}/>
        {/* <TalkToCareGuideButton/> */}
    </Fragment>
  );
};

export default Home;
